module.exports = __webpack_public_path__ + "images/commercial_exhibit_room.png";